<div class="d-flex wrapper" [ngClass]="{'justify-content-end': listLayout}">
  <div
    class="campaign-type type fontsize14"
    *ngFor="let type of campaignTypes"
    [ngbTooltip]="typeTooltip"
    tooltipClass="my-configurations-tooltip"
    [ngClass]="{
                    'CPL': type.id === 1,
                    'CPS': type.id === 2,
                    'CPA': type.id === 3,
                    'PPI': type.id === 4,
                    'COD': type.id === 5
                }">
    <ng-container *ngIf="type"> {{ type?.system_name ?? '' | translate }} </ng-container>
    <ng-template #typeTooltip>{{ type?.system_name ?? '' | translate }}</ng-template>
  </div>
  <div class="campaign-commision commision fontsize14" *ngIf="campaign?.rate" tooltipClass="my-configurations-tooltip" [ngbTooltip]="rateTooltip">
    <nb-icon icon="payouts" pack="icomoon" class="payouts-icon"></nb-icon>
    <p>{{ campaign?.rate }}</p>
    <ng-template #rateTooltip>{{ campaign?.rate }}</ng-template>
  </div>
  <div class="campaign-commision commision fontsize14" *ngIf="campaign?.payment" tooltipClass="my-configurations-tooltip" [ngbTooltip]="rateTooltip">
    <nb-icon icon="payouts" pack="icomoon" class="payouts-icon"></nb-icon>
    <p>{{ campaign?.payment }}</p>
    <ng-template #rateTooltip>{{ campaign?.payment }}</ng-template>
  </div>
</div>
